var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5856 0.121094H1.60922C0.739691 0.121094 0.0332031 0.837463 0.0332031 1.71687V20.6587C0.0332031 21.5381 0.739691 22.2544 1.60922 22.2544H20.5856C21.4551 22.2544 22.1665 21.5381 22.1665 20.6587V1.71687C22.1665 0.837463 21.4551 0.121094 20.5856 0.121094ZM6.72261 19.0925H3.44213V8.52978H6.72755V19.0925H6.72261ZM5.08237 7.08717C4.03005 7.08717 3.18029 6.23246 3.18029 5.18508C3.18029 4.1377 4.03005 3.283 5.08237 3.283C6.12975 3.283 6.98445 4.1377 6.98445 5.18508C6.98445 6.2374 6.13469 7.08717 5.08237 7.08717ZM19.0195 19.0925H15.739V13.9544C15.739 12.7292 15.7143 11.1532 14.0345 11.1532C12.3251 11.1532 12.0633 12.4871 12.0633 13.8655V19.0925H8.78279V8.52978H11.9299V9.9724H11.9743C12.414 9.1424 13.4861 8.26794 15.0819 8.26794C18.4019 8.26794 19.0195 10.4566 19.0195 13.3023V19.0925Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.08f1899663e873ecca233403b82ed7d4.svg";
export { ForwardRef as ReactComponent };